import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      border: 'none',
      overflow: 'hidden',
      maxHeight: '100%',
      cursor: 'pointer',
      borderRadius: 30,
      textDecoration: 'none',
      background: '#B79DFF9E',
      padding: '20px 20px 30px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    headerLabel: {
      alignSelf: 'start',
      marginBottom: 22,
      fontSize: 16,
      fontWeight: 500,
      lineHeight: 1
    },
    icon: {
      width: 100,
      height: 100,
      marginBottom: 22
    },
    title: {
      color: theme.palette.text.primary,
      textAlign: 'center',
      overflow: 'hidden',
      whiteSpace: 'normal',
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 1,
      textOverflow: 'ellipsis',
      fontSize: 22,
      lineHeight: 1,
      fontWeight: 500,
      marginBottom: 5
    },
    subtitle: {
      fontSize: 26,
      fontWeight: 700,
      marginBottom: 22

    },
    button: {
      alignSelf: 'stretch'
    }
  }),
{ name: 'CardWinner' }
);
